import { getUrlParams } from 'utils/url';
import { getCookieItem } from 'utils/browserCache';

import { IDENTIFY_TYPES } from 'constants/id';
import { UserIdentifierType } from './types';

/**
 * Get unique identifier values.
 * For web = browserCookieId (bcid).
 * For iOS Webview/localhost = carvanaDeviceId (cdid) and does not always exist.
 */
export const getUserIdentifier = (): UserIdentifierType => {
  const browserCookieId = getCookieItem(IDENTIFY_TYPES.BROWSER_COOKIE_ID) || '';
  const carvanaDeviceId = getUrlParams(IDENTIFY_TYPES.CARVANA_DEVICE_ID) || null;

  const userIdentifierType = carvanaDeviceId
    ? IDENTIFY_TYPES.CARVANA_DEVICE_ID
    : IDENTIFY_TYPES.BROWSER_COOKIE_ID;

  return { browserCookieId, carvanaDeviceId, userIdentifierType };
};
